<template>
    <div>
        <div
            v-for="(item, index) in data"
            :key="index"
            class="project-list-context"
        >
            <div class="project-list-context__inner" @click="handleClick(item)">
                <div class="title-icon">
                    <img src="../assets/icon/1-提示-截止时间-图标@2x.png">
                    <span :class="`status kai-biao-status${item.kbStatus}`">
                        {{
                            `${item.kbStatus === 1 ? "距离开标时间 " : ""}` + item.restTime
                        }}
                    </span>
                </div>
                <p>
                    {{ item.title }}
                </p>
                <div class="project-list-context__inner-sub">
                    <span> 项目编号: {{ item.code }}</span>
                    <br>
                    <span> 开标时间: {{ item.kbTimeText }}</span>
                </div>
                <!-- <div class="project-list-context__inner-type">
                    <span>
                        {{ item.type }}
                    </span>
                    <span>
                        {{ item.type }}
                    </span>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: Array,
                default: () => [],
            },
        },
        methods: {
            handleClick(item) {
                this.$emit('handleClick', item)
            },
        },
    }
</script>

<style>
</style>
